var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowCircleRightWhiteIcon = function SvgArrowCircleRightWhiteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 49 49"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M33.968 23.692a.9.9 0 0 0-.212-.31l-8.445-8.087a.98.98 0 0 0-1.347 0 .885.885 0 0 0 0 1.29l6.82 6.53H14.986c-.526 0-.952.41-.952.913s.426.912.952.912h15.796l-6.819 6.53a.885.885 0 0 0 0 1.29.98.98 0 0 0 1.347 0l8.44-8.083.046-.046a.9.9 0 0 0 .238-.603M33.968 23.692a.9.9 0 0 1 .067.333z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    x: 1.035,
    y: 1.028,
    stroke: "#fff",
    strokeWidth: 2,
    rx: 23
  })));
};
export default SvgArrowCircleRightWhiteIcon;